import VueRouter from 'vue-router'
import routes from '../routes.js'

export default new VueRouter({
  // mode: 'history', <-- but for now, because we are using render.com, this doesn't work.
  routes,
})
